import { createContext } from 'react';

export const NgBridgeCheckerContext = createContext({ present: false });

/**
 * This provider can wrap a component to find out if any components down the tree are using
 * bridging hooks. This should never be shipped to production and is only used for debugging purposes.
 */

export const NgBridgeCheckerProvider = ({
  children,
}: {
  children: React.ReactChild;
}): JSX.Element => (
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  <NgBridgeCheckerContext.Provider value={{ present: true }}>
    {children}
  </NgBridgeCheckerContext.Provider>
);
